import { store } from "@/store";
import { serverBus } from "@/main";

export default {
  namespaced: true,
  state: {
    loading: false,
  },
  getters: {
    isLoading: (state) => state.loading,
  },
  mutations: {
    setLoading(state, isLoading) {
      state.loading = isLoading;
    },
  },
  actions: {
    async completedTask({ commit, rootGetters }) {
      // commit("setLoading", true);
      // try {
      //   await this._vm.$http({
      //     url: `/api/v1/client/points/1`,
      //     method: "PUT",
      //     headers: {
      //       "content-type": "application/json",
      //       Authorization: rootGetters.authToken,
      //     },
      //   });
      //   store.dispatch("getUser");
      //   serverBus.$emit("globalNotification", {
      //     m: "Task Completed!",
      //     type: "success",
      //   });
      //   commit("setLoading", false);
      // } catch (error) {
      //   commit("setLoading", false);
      //   throw error;
      // }
    },
    /**
     * Reset state to initial values
     *
     * @param commit
     */
    reset({ commit }) {
      commit("setLoading", false);
    },
  },
};
